define(require => {
	const Backbone = require('backbone');
	const Modal = require('backbone.modal');
	const ConfirmationModalTemplate = require('civicsViews/core/confirmation/templates/t_mv_confirmation.hbs');
	const Radio = require('backbone.radio');
	const ConfirmationChannel = Radio.channel('confirmationChannel');
	var IpsModel = require('civicsBase/ipsModel');

	return Backbone.Modal.extend({
		template: ConfirmationModalTemplate,
		cancelEl: '.btn-cancel-confirmation',
		submitEl: '.btn-continue-confirmation',
		//It is possible to send in a className that also will be added to the bbm-modal
		attributes: function() {
			return {
				class: this.className,
			}
		},
		initialize: function(options) {
			this.model = (options.model) ? options.model : new IpsModel();
			this.modalTitle = options.title;
			this.modalMessage = options.message;
			this.className = options.className;
		},
		events: {
			'click .btn-continue-confirmation': 'continueClicked'
		},
		continueClicked: function() {
			ConfirmationChannel.trigger('confirmation:continue', this.model);
		},
		// need to explicitly override this method since backbone.modal is not an instance of a marionette view
		// TECH DEBT: find a way to DRY this so that we don't have to replicate in each modal separately
		buildTemplate: function(template, data) {
			var templateFunction;

			// extend the data object to include a function for translation injection
			var _data = _.extend(data, {
				t: function(i18nKey, options) {
					return new Handlebars.SafeString(i18n.t(i18nKey, options || {}));
				},
				tr: function(context, options) {
					var opts = i18n.functions.extend(options.hash, context);
					if (options.fn) {
						opts.defaultValue = options.fn(context);
					}
					return new Handlebars.SafeString(i18n.t(opts.key, opts));
				},
				// add data
				modalMessage: this.modalMessage,
				modalTitle: this.modalTitle,
			});

			// continue with template rendering
			if (typeof template === 'function') {
				templateFunction = template;
			} else {
				templateFunction = _.template(Backbone.$(template).html());
			}

			return templateFunction(_data);
		},
	});
});
